import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorhandlingService } from './errorhandling.service';
import { SettingsDTO, SettingsWriteDTO } from '../interfaces/settings';
import { TaskWriteDTO } from '../interfaces/task';
import { ProviderDTO } from '../interfaces/provider';
import { NoteDTO, NoteWriteDTO } from '../interfaces/note';
import { EventDTO, EventViewDTO, EventWriteDTO } from '../interfaces/event';
import { DeploymentVersionDTO } from '../interfaces/deploymentVersion';
import { CalendarDTO, CalendarWriteDTO } from '../interfaces/calendar';
import { CalendarIntegrationDTO, CalendarIntegrationWriteDTO } from '../interfaces/calendarIntegration';
import { AppRegistrationDTO, AppRegistrationWriteDTO } from '../interfaces/appRegistration';
import { TimeZoneDTO } from '../interfaces/timeZone';
import { MailWriteDTO } from '../interfaces/mail';
import { AccountWriteDTO } from '../interfaces/account';
import { UserDTO, UserPatchDTO, UserWriteDTO } from '../interfaces/user';
import { AccountTypeDTO } from '../interfaces/accountType';
import { ICalDTO, ICalWriteDTO } from '../interfaces/iCal';
import { CaldavDTO, CaldavWriteDTO } from '../interfaces/calDav';
import { ListItemDTO, ListItemWriteDTO } from '../interfaces/listItem';
import { ListDTO, ListWriteDTO, SharedListMemberDTO } from '../interfaces/list';
import { RecordingDTO, RecordingWriteDTO } from '../interfaces/recording';
import { RoleDTO } from '../interfaces/role';
import { FeatureDTO } from '../interfaces/feature';
import { SubscriptionDTO } from '../interfaces/subscription';
import { UserSubscriptionDTO, UserSubscriptionNumberDTO, UserSubscriptionWriteDTO } from '../interfaces/userSubscription';
import { FeatureSubscriptionDTO, FeatureSubscriptionWriteDTO } from '../interfaces/featureSubscription';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const httpOptions2 = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
  // Ignore this part or  if you want full response you have 
  // to explicitly give as 'boby'as http client by default give res.json()
  //observe:'response' as 'body',
  observe: 'response' as 'body',

  // have to explicitly give as 'blob' or 'json'
  //responseType: 'blob' as 'blob'
  responseType: 'blob' as 'json'
};

@Injectable({
  providedIn: 'root'
})
export class DataService {

  authenticationUrl = environment.apiURL + '/api/authentication';  // URL to web api
  validateUserNameUrl = environment.apiURL + '/api/authentication/validateUserName';
  validateEmailUrl = environment.apiURL + '/api/authentication/validateEmail';
  monitoringUrl = environment.apiURL + "/actuator/health";
  getConsentUrl = environment.apiURL + "/api/getConsent";
  removeConsentUrl = environment.apiURL + "/api/removeConsent";
  callBackUrl = environment.apiURL + "/api/callBack";
  calendarsUrl = environment.apiURL + "/api/calendars";
  allCalendarsUrl = environment.apiURL + "/api/allCalendars";
  calendarUrl = environment.apiURL + "/api/calendar";
  getTimeZonesUrl = environment.apiURL + "/api/getTimeZones";
  providersUrl = environment.apiURL + "/api/providers";
  settingsUrl = environment.apiURL + "/api/settings";
  consentGivenUrl = environment.apiURL + "/api/consentGiven";
  notesUrl = environment.apiURL + "/api/notes";
  revisionsUrl = environment.apiURL + "/api/revisions"
  hasRevisionsUrl = environment.apiURL + "/api/hasRevisions";
  toggleArchiveUrl = environment.apiURL + '/api/note/toggleArchive';
  noteUrl = environment.apiURL + "/api/note";
  searchNotesUrl = environment.apiURL + '/api/searchNotes';
  deleteNoteUrl = environment.apiURL + "/api/deleteNote";
  createNoteForUpcomingEventUrl = environment.apiURL + "/api/createNoteForUpcomingEvent";
  createNoteForEventUrl = environment.apiURL + "/api/createNoteForEvent";
  syncUrl = environment.apiURL + "/api/sync";
  upcomingEventsUrl = environment.apiURL + "/api/upcomingEvents";
  eventsInRangeUrl = environment.apiURL + "/api/eventsInRange";
  dashboardOverviewUrl = environment.apiURL + "/api/dashboardOverview";
  eventUrl = environment.apiURL + "/api/event";
  sendMailUrl = environment.apiURL + "/api/sendMail";
  updateAccountUrl = environment.apiURL + "/api/account";
  resetPasswordUrl = environment.apiURL + "/api/authentication/resetPassword";
  setNewPasswordUrl = environment.apiURL + "/api/authentication/setNewPassword";
  getMailCountUrl = environment.apiURL + "/api/authentication/mailCount";
  tasksUrl = environment.apiURL + "/api/tasks";
  taskUrl = environment.apiURL + "/api/task";
  listsUrl = environment.apiURL + "/api/lists";
  sharedListsUrl = environment.apiURL + "/api/sharedLists";
  shareListUrl = environment.apiURL + "/api/shareList";
  listUrl = environment.apiURL + "/api/list";
  listItemsUrl = environment.apiURL + "/api/listItems";
  listItemUrl = environment.apiURL + "/api/listItem";
  updateListItemPositionUrl = environment.apiURL + "/api/updateListItemPosition";
  sharedListMembersUrl = environment.apiURL + "/api/sharedListMembers";
  sharedListMemberUrl = environment.apiURL + "/api/sharedListMember";
  numberOfTasksForNoteUrl = environment.apiURL + "/api/numberOfTasksForNote";
  tasksForDueDateUrl = environment.apiURL + "/api/tasksForDueDate";
  calendarIntegrationsUrl = environment.apiURL + "/api/calendarIntegrations";
  calendarIntegrationUrl = environment.apiURL + "/api/calendarIntegration";
  deleteCalendarIntegrationUrl = environment.apiURL + "/api/deleteCalendarIntegration";
  providerForCalendarIntegration = environment.apiURL + "/api/providerForCalendarIntegration";
  userUrl = environment.apiURL + '/api/user';
  appRegistrationsUrl = environment.apiURL + "/api/appRegistrations";
  appRegistrationUrl = environment.apiURL + "/api/appRegistration";
  deleteAppRegistrationUrl = environment.apiURL + "/api/deleteAppRegistration";
  latestDeploymentVersionUrl = environment.apiURL + "/api/latestDeploymentVersion";
  accountTypesUrl = environment.apiURL + "/api/accountTypes";
  accountTypeUrl = environment.apiURL + "/api/accountType";
  iCalsUrl = environment.apiURL + "/api/iCals";
  iCalUrl = environment.apiURL + "/api/iCal";
  caldavsUrl = environment.apiURL + "/api/caldavs";
  caldavUrl = environment.apiURL + "/api/caldav";
  testCaldavAccountUrl = environment.apiURL + "/api/testCaldavAccount";
  testICalUrlUrl = environment.apiURL + "/api/testICalUrl";
  discoverCalDavCalendarsUrl = environment.apiURL + "/api/discoverCalDavCalendars";
  updateCaldavPasswordUrl = environment.apiURL + "/api/updateCaldavPassword";
  recordingUrl = environment.apiURL + "/api/recording";
  uploadRecordingUrl = environment.apiURL + "/api/uploadRecording";
  refreshTokenUrl = environment.apiURL + "/api/refreshToken";
  deleteUserUrl = environment.apiURL + "/api/deleteUser";
  roleUrl = environment.apiURL + "/api/role";
  hasFeatureUrl = environment.apiURL + "/api/hasFeature";
  userSubscriptionUrl = environment.apiURL + "/api/userSubscription";
  createCheckoutSessionUrl = environment.apiURL + "/api/v1/stripe/create-checkout-session";
  createPortalSessionUrl = environment.apiURL + "/api/v1/stripe/create-portal-session";
  subscriptionUrl = environment.apiURL + "/api/subscription";

  //admin part
  featuresAdminUrl = environment.apiURL + "/api/admin/features";
  featureAdminUrl = environment.apiURL + "/api/admin/feature";
  subscriptionsAdminUrl = environment.apiURL + "/api/admin/subscriptions";
  userSubscriptionAdminUrl = environment.apiURL + "/api/admin/userSubscription";
  userSubscriptionsAdminUrl = environment.apiURL + "/api/admin/userSubscriptions";
  userSubscriptionNumbersAdminUrl = environment.apiURL + "/api/admin/userSubscriptionNumbers";
  featureSubscriptionsAdminUrl = environment.apiURL + "/api/admin/featureSubscriptions";
  featureSubscriptionAdminUrl = environment.apiURL + "/api/admin/featureSubscription";

  parameters: string = "";

  constructor(private http: HttpClient, private errorhandling: ErrorhandlingService) { }

  login(email: string, password: string, deviceId: string): Observable<any> {
    return this.http.post(this.authenticationUrl + '/signin', {
      email,
      password,
      deviceId
    }, httpOptions);
  }

  register(data: any): Observable<any> {
    return this.http.post(this.authenticationUrl + '/signup', data, httpOptions);
  }

  validateEmail(data: any): Observable<any> {
    return this.http.post(this.validateEmailUrl, data, httpOptions);
  }

  refreshToken(refreshToken: string, deviceId: string) {
    return this.http.get<UserDTO>(this.refreshTokenUrl + '?refreshToken=' + refreshToken + '&deviceId=' + deviceId, httpOptions);
  }

  getLatestDeploymentVersion(): Observable<any> {
    return this.http.get<DeploymentVersionDTO[]>(this.latestDeploymentVersionUrl, httpOptions);
  }

  getCalendarIntegrations(): Observable<CalendarIntegrationDTO[]> {
    return this.http.get<CalendarIntegrationDTO[]>(this.calendarIntegrationsUrl, httpOptions);
  }

  getCalendarIntegrationsWithCalendarsToShow(): Observable<CalendarIntegrationDTO[]> {
    const value = true;
    return this.http.get<CalendarIntegrationDTO[]>(this.calendarIntegrationsUrl + '?filterOnCalendars=' + value, httpOptions);
  }

  getCalendarIntegration(calendarIntegrationId: number): Observable<CalendarIntegrationDTO> {
    return this.http.get<CalendarIntegrationDTO>(this.calendarIntegrationUrl + '?calendarIntegrationId=' + calendarIntegrationId, httpOptions);
  }

  createCalendarIntegration(calendarIntegration: CalendarIntegrationWriteDTO): Observable<any> {
    return this.http.post(this.calendarIntegrationUrl, calendarIntegration, httpOptions);
  }

  updateCalendarIntegration(id: number, calendarIntegration: CalendarIntegrationWriteDTO): Observable<any> {
    return this.http.put(this.calendarIntegrationUrl + "/" + id, calendarIntegration, httpOptions);
  }

  deleteCalendarIntegration(id: number): Observable<any> {
    return this.http.delete(this.calendarIntegrationUrl + "/" + id, httpOptions);
  }

  getProviderForCalendarIntegration(id: number): Observable<any> {
    return this.http.get(this.providerForCalendarIntegration + "?calendarIntegrationId=" + id, httpOptions);
  }

  getConsent(calendarIntegrationId: number, forceReconsent: boolean): Observable<any> {
    return this.http.get<any>(this.getConsentUrl + "?calendarIntegrationId=" + calendarIntegrationId + "&forceReconsent=" + forceReconsent, httpOptions);
  }

  consentGiven(): Observable<any> {
    return this.http.get<any>(this.consentGivenUrl, httpOptions);
  }

  removeConsent(providerId: number): Observable<any> {
    return this.http.get<any>(this.removeConsentUrl + "/?providerId=" + providerId, httpOptions);
  }

  callBack(code: string, state: string) {
    return this.http.get<any>(this.callBackUrl + "?code=" + code + "&state=" + state, httpOptions)
  }

  getCalendar(calendarId: number): Observable<CalendarDTO> {
    return this.http.get<CalendarDTO>(this.calendarUrl + '?calendarId=' + calendarId, httpOptions);
  }

  getCalendars(calendarIntegrationId: number, showInDashboard: boolean): Observable<CalendarDTO[]> {
    return this.http.get<CalendarDTO[]>(this.calendarsUrl + '?calendarIntegrationId=' + calendarIntegrationId + '&showInDashboard=' + showInDashboard, httpOptions);
  }

  getAllCalendars(): Observable<CalendarDTO[]> {
    return this.http.get<CalendarDTO[]>(this.allCalendarsUrl, httpOptions);
  }

  getCalendarsForDashboard(): Observable<CalendarDTO[]> {
    return this.http.get<CalendarDTO[]>(this.calendarsUrl + '/dashboard', httpOptions);
  }

  getCalendarsForNotes(): Observable<CalendarDTO[]> {
    return this.http.get<CalendarDTO[]>(this.calendarsUrl + '/notes', httpOptions);
  }

  createCalendar(calendar: CalendarWriteDTO): Observable<any> {
    return this.http.post(this.calendarUrl, calendar, httpOptions);
  }

  updateCalendar(id: number, calendar: CalendarWriteDTO): Observable<any> {
    return this.http.put(this.calendarUrl + "/" + id, calendar, httpOptions);
  }

  deleteCalendar(id: number): Observable<any> {
    return this.http.delete(this.calendarUrl + "/" + id, httpOptions);
  }

  getTimeZones(): Observable<TimeZoneDTO[]> {
    return this.http.get<TimeZoneDTO[]>(this.getTimeZonesUrl, httpOptions);
  }

  getProviders(): Observable<ProviderDTO[]> {
    return this.http.get<ProviderDTO[]>(this.providersUrl, httpOptions);
  }

  getAccountTypes(): Observable<AccountTypeDTO[]> {
    return this.http.get<AccountTypeDTO[]>(this.accountTypesUrl, httpOptions);
  }

  getAccountType(id: number): Observable<AccountTypeDTO> {
    return this.http.get<AccountTypeDTO>(this.accountTypeUrl + '?accountTypeId=' + id, httpOptions);
  }

  getSettings(): Observable<any> {
    return this.http.get<SettingsDTO>(this.settingsUrl, httpOptions);
  }

  createSettings(settings: SettingsWriteDTO): Observable<any> {
    return this.http.post(this.settingsUrl, settings, httpOptions);
  }

  updateSettings(id: number, settings: SettingsWriteDTO): Observable<any> {
    return this.http.put(this.settingsUrl + "/" + id, settings, httpOptions);
  }

  deleteSettings(id: number): Observable<any> {
    return this.http.delete(this.settingsUrl + "/" + id, httpOptions);
  }

  getNote(noteId: number): Observable<NoteDTO> {
    return this.http.get<NoteDTO>(this.noteUrl + '?noteId=' + noteId, httpOptions);
  }

  getNotes(calendarId: number): Observable<NoteDTO[]> {
    return this.http.get<NoteDTO[]>(this.notesUrl + '?calendarId=' + calendarId, httpOptions);
  }

  getNotesForCalendar(calendarId: number): Observable<NoteDTO[]> {
    return this.http.get<NoteDTO[]>(this.notesUrl + '/calendar?calendarId=' + calendarId, httpOptions);
  }

  searchNotes(calendarId: number, searchTerm: string): Observable<NoteDTO[]> {
    return this.http.get<NoteDTO[]>(this.searchNotesUrl + '?calendarId=' + calendarId + '&searchTerm=' + searchTerm, httpOptions);
  }

  createNote(note: NoteWriteDTO): Observable<any> {
    return this.http.post(this.noteUrl, note, httpOptions);
  }

  updateNote(id: number, note: NoteWriteDTO): Observable<any> {
    return this.http.put(this.noteUrl + "/" + id, note, httpOptions);
  }

  deleteNote(id: number): Observable<any> {
    return this.http.delete(this.noteUrl + "/" + id, httpOptions);
  }

  createNoteForUpcomingEvent(calendarId: number, upcoming: EventDTO, timeZone: string): Observable<any> {
    return this.http.post(this.createNoteForUpcomingEventUrl + '?calendarId=' + calendarId + '&timeZone=' + encodeURIComponent(timeZone), upcoming, httpOptions);
  }

  createNoteForEvent(eventId: number, startDateISO: string): Observable<any> {
    return this.http.post(this.createNoteForEventUrl + '?eventId=' + eventId + '&startDateISO=' + startDateISO, httpOptions);
  }

  getRevisions(calendarId: number, uuid: string): Observable<NoteDTO[]> {
    return this.http.get<NoteDTO[]>(this.revisionsUrl + '?calendarId=' + calendarId + '&uuid=' + uuid, httpOptions);
  }

  hasRevisions(calendarId: number, uuid: string): Observable<number> {
    return this.http.get<any>(this.hasRevisionsUrl + '?calendarId=' + calendarId + '&uuid=' + uuid, httpOptions);
  }

  toggleArchive(noteId: number): Observable<any> {
    return this.http.put(this.toggleArchiveUrl + "/" + noteId, httpOptions);
  }

  getUpcomingEvents(calendarId: number): Observable<EventViewDTO[]> {
    return this.http.get<EventViewDTO[]>(this.upcomingEventsUrl + '?calendarId=' + calendarId, httpOptions);
  }

  getEventsInRange(calendarId: number, startDateISO: string, endDateISO: string) {
    return this.http.get<EventViewDTO[]>(this.eventsInRangeUrl + '?calendarId=' + calendarId + '&startDateISO=' + startDateISO + '&endDateISO=' + endDateISO, httpOptions);
  }

  getDashboardOverview(startDateISO: string, endDateISO: string) {
    return this.http.get<EventViewDTO[]>(this.dashboardOverviewUrl + '?startDateISO=' + startDateISO + '&endDateISO=' + endDateISO, httpOptions);
  }

  createEvent(event: EventWriteDTO): Observable<any> {
    return this.http.post(this.eventUrl, event, httpOptions);
  }

  addEvent(event: EventWriteDTO): Observable<any> {
    return this.http.post<EventViewDTO>(this.eventUrl, event, httpOptions);
  }

  updateEvent(id: number, scope: string, event: EventWriteDTO): Observable<any> {
    return this.http.put<EventViewDTO>(this.eventUrl + "/" + id + "?scope=" + scope, event, httpOptions);
  }

  deleteEvent(id: number, scope: string, occurrenceDate?: string): Observable<any> {
    if (occurrenceDate) {
      return this.http.delete(this.eventUrl + "/" + id + "?scope=" + scope + "&occurenceDate=" + occurrenceDate, httpOptions);
    } else {
      return this.http.delete(this.eventUrl + "/" + id + "&scope=" + scope, httpOptions);
    }
  }

  sendMail(mail: MailWriteDTO): Observable<any> {
    return this.http.post(this.sendMailUrl, mail, httpOptions);
  }

  getMailCount(): Observable<any> {
    return this.http.get(this.getMailCountUrl, httpOptions);
  }

  updateAccount(accountId: number, account: AccountWriteDTO): Observable<any> {
    console.log('dataService.updateAccount', account);
    return this.http.post(this.updateAccountUrl, account, httpOptions);
  }

  saveUser(user: UserDTO): Observable<any> {
    return this.http.post(this.userUrl, user, httpOptions);
  }

  deleteUser(credentials: any): Observable<any> {
    const options = {
      ...httpOptions,
      body: credentials
    };
    return this.http.delete(this.deleteUserUrl, options)
  }

  resetPassword(email: string): Observable<any> {
    return this.http.post(this.resetPasswordUrl, email, httpOptions);
  }

  setNewPassword(username: string, password: string, token: string): Observable<any> {
    return this.http.post(this.setNewPasswordUrl, { username, password, token }, httpOptions);
  }

  getTasks(calendarId: number, status: string): Observable<Task[]> {
    return this.http.get<Task[]>(this.tasksUrl + '?calendarId=' + calendarId + '&status=' + status, httpOptions);
  }

  getTask(taskId: number): Observable<Task[]> {
    return this.http.get<Task[]>(this.taskUrl + '?taskId=' + taskId, httpOptions);
  }

  getNumberOfTasksForNote(noteId: number): Observable<any> {
    return this.http.get(this.numberOfTasksForNoteUrl + '?noteId=' + noteId, httpOptions);
  }

  getTasksForDueDate(calendarId: number, dueDate: string): Observable<any> {
    return this.http.get(this.tasksForDueDateUrl + '?calendarId=' + calendarId + '&endRangeISO=' + dueDate, httpOptions);
  }

  createTask(task: TaskWriteDTO): Observable<any> {
    return this.http.post(this.taskUrl, task, httpOptions);
  }

  updateTask(id: number, task: TaskWriteDTO): Observable<any> {
    return this.http.put(this.taskUrl + "/" + id, task, httpOptions);
  }

  deleteTask(id: number): Observable<any> {
    return this.http.delete(this.taskUrl + "/" + id, httpOptions);
  }

  getAppRegistrations(): Observable<AppRegistrationDTO[]> {
    return this.http.get<AppRegistrationDTO[]>(this.appRegistrationsUrl, httpOptions);
  }

  getAppRegistration(appRegistrationId: number): Observable<Task[]> {
    return this.http.get<Task[]>(this.appRegistrationUrl + '?appRegistrationId=' + appRegistrationId, httpOptions);
  }

  createAppRegistration(appRegistration: AppRegistrationWriteDTO): Observable<any> {
    return this.http.post(this.appRegistrationUrl, appRegistration, httpOptions);
  }

  updateAppRegistration(id: number, appRegistration: AppRegistrationWriteDTO): Observable<any> {
    return this.http.put(this.appRegistrationUrl + "/" + id, appRegistration, httpOptions);
  }

  deleteAppRegistration(id: number): Observable<any> {
    return this.http.delete(this.appRegistrationUrl + "/" + id, httpOptions);
  }

  createUser(user: UserWriteDTO): Observable<any> {
    return this.http.post(this.userUrl, user, httpOptions);
  }

  updateUserRole(id: number, user: UserPatchDTO): Observable<any> {
    return this.http.patch(this.userUrl + "/" + id + "/role", user, httpOptions);
  }

  updateUserEmail(id: number, user: UserPatchDTO): Observable<any> {
    return this.http.patch(this.userUrl + "/" + id + "/email", user, httpOptions);
  }

  updateUserLastLogin(id: number): Observable<any> {
    return this.http.patch(this.userUrl + "/" + id + "/lastLogin", httpOptions);
  }

  updateUserCalendar(id: number, user: UserPatchDTO): Observable<any> {
    return this.http.patch(this.userUrl + "/" + id + "/calendar", user, httpOptions);
  }

  updateUserConditions(id: number, user: UserPatchDTO): Observable<any> {
    return this.http.patch(this.userUrl + "/" + id + "/conditions", user, httpOptions);
  }

  getICals(): Observable<ICalDTO[]> {
    return this.http.get<ICalDTO[]>(this.iCalsUrl, httpOptions);
  }

  getICal(iCalId: number): Observable<ICalDTO> {
    return this.http.get<ICalDTO>(this.iCalUrl + '?iCalId=' + iCalId, httpOptions);
  }

  createICal(iCal: ICalWriteDTO): Observable<any> {
    return this.http.post(this.iCalUrl, iCal, httpOptions);
  }

  updateICal(id: number, iCal: ICalWriteDTO): Observable<any> {
    return this.http.put(this.iCalUrl + "/" + id, iCal, httpOptions);
  }

  deleteICal(id: number): Observable<any> {
    return this.http.delete(this.iCalUrl + "/" + id, httpOptions);
  }

  testICalUrl(url: string): Observable<any> {
    return this.http.post(this.testICalUrlUrl, url, httpOptions);
  }

  getCaldavs(): Observable<CaldavDTO[]> {
    return this.http.get<CaldavDTO[]>(this.caldavsUrl, httpOptions);
  }

  getCaldav(calDavId: number): Observable<CaldavDTO> {
    return this.http.get<CaldavDTO>(this.caldavUrl + '?calDavId=' + calDavId, httpOptions);
  }

  createCaldav(caldav: CaldavWriteDTO): Observable<any> {
    return this.http.post(this.caldavUrl, caldav, httpOptions);
  }

  updateCaldav(id: number, caldav: CaldavWriteDTO): Observable<any> {
    return this.http.put(this.caldavUrl + "/" + id, caldav, httpOptions);
  }

  deleteCaldav(id: number): Observable<any> {
    return this.http.delete(this.caldavUrl + "/" + id, httpOptions);
  }

  testCaldavAccount(caldav: CaldavWriteDTO): Observable<any> {
    return this.http.post(this.testCaldavAccountUrl, caldav, httpOptions);
  }

  discoverCalDavCalendars(caldav: CaldavWriteDTO): Observable<any> {
    return this.http.post(this.discoverCalDavCalendarsUrl, caldav, httpOptions);
  }

  updateCaldavPassword(id: number, password: string): Observable<any> {
    return this.http.post(this.updateCaldavPasswordUrl + "/" + id, password, httpOptions);
  }

  getListItems(listId: number): Observable<ListItemDTO[]> {
    return this.http.get<ListItemDTO[]>(this.listItemsUrl + '?listId=' + listId, httpOptions);
  }

  getListItem(listItemId: number): Observable<ListItemDTO> {
    return this.http.get<ListItemDTO>(this.listItemUrl + '?listItemId=' + listItemId, httpOptions);
  }

  createListItem(listItem: ListItemWriteDTO): Observable<any> {
    return this.http.post(this.listItemUrl, listItem, httpOptions);
  }

  updateListItem(id: number, listItem: ListItemWriteDTO): Observable<any> {
    return this.http.put(this.listItemUrl + "/" + id, listItem, httpOptions);
  }

  updateListItemPosition(id: number, position: number): Observable<any> {
    return this.http.put(this.updateListItemPositionUrl + "/" + id, position, httpOptions);
  }

  deleteListItem(id: number): Observable<any> {
    return this.http.delete(this.listItemUrl + "/" + id, httpOptions);
  }

  getLists(): Observable<ListDTO[]> {
    return this.http.get<ListDTO[]>(this.listsUrl, httpOptions);
  }

  getSharedLists(): Observable<ListDTO[]> {
    return this.http.get<ListDTO[]>(this.sharedListsUrl, httpOptions);
  }

  shareList(listId: number, emailAddress: string) {
    return this.http.post(this.shareListUrl + "?listId=" + listId, emailAddress, httpOptions);
  }

  getList(listId: number): Observable<ListDTO> {
    return this.http.get<ListDTO>(this.listUrl + '?listId=' + listId, httpOptions);
  }

  createList(list: ListWriteDTO): Observable<any> {
    return this.http.post(this.listUrl, list, httpOptions);
  }

  updateList(id: number, list: ListWriteDTO): Observable<any> {
    return this.http.put(this.listUrl + "/" + id, list, httpOptions);
  }

  deleteList(id: number): Observable<any> {
    return this.http.delete(this.listUrl + "/" + id, httpOptions);
  }

  getSharedListMembers(listId: number) {
    return this.http.get<SharedListMemberDTO[]>(this.sharedListMembersUrl + '?listId=' + listId, httpOptions);
  }

  addSharedListMember(sharedListMember: SharedListMemberDTO): Observable<any> {
    return this.http.post(this.sharedListMemberUrl, sharedListMember, httpOptions);
  }

  removeSharedListMember(sharedListMember: SharedListMemberDTO) {
    return this.http.delete(this.sharedListMemberUrl, {
      ...httpOptions,
      body: sharedListMember
    });
  }

  getRecording(id: number): Observable<RecordingDTO> {
    return this.http.get<RecordingDTO>(this.recordingUrl + '?id=' + id, httpOptions);
  }

  createRecording(recording: RecordingWriteDTO): Observable<any> {
    return this.http.post(this.recordingUrl, recording, httpOptions);
  }

  updateRecording(id: number, recording: RecordingWriteDTO): Observable<any> {
    return this.http.put(this.recordingUrl + "/" + id, recording, httpOptions);
  }

  uploadRecording(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.uploadRecordingUrl + "?id=" + id, formData);
  }

  deleteRecording(id: number): Observable<any> {
    return this.http.delete(this.recordingUrl + "/" + id, httpOptions);
  }

  getRole(): Observable<any> {
    return this.http.get<RoleDTO>(this.roleUrl, httpOptions);
  }

  getFeature(feature: string): Observable<any> {
    return this.http.get<FeatureDTO>(this.hasFeatureUrl + "?feature=" + feature, httpOptions);
  }

  getFeatures(page: number, size: number): Observable<any> {
    return this.http.get<FeatureDTO[]>(this.featuresAdminUrl + '?page=' + page + '&size=' + size, httpOptions);
  }

  toggleFeatureEnabled(id: number, enabled: boolean): Observable<any> {
    return this.http.patch(this.featureAdminUrl + "/" + id + "?enabled=" + enabled, httpOptions);
  }

  getSubscription(code: string) {
    return this.http.get<SubscriptionDTO>(this.subscriptionUrl + "?code=" + code, httpOptions);
  }
  getSubscriptions(page: number, size: number): Observable<any> {
    return this.http.get<SubscriptionDTO[]>(this.subscriptionsAdminUrl + '?page=' + page + '&size=' + size, httpOptions);
  }

  getUserSubscriptions(page: number, size: number): Observable<any> {
    return this.http.get<UserSubscriptionDTO[]>(this.userSubscriptionsAdminUrl + '?page=' + page + '&size=' + size, httpOptions);
  }

  getUserSubscription(): Observable<any> {
    return this.http.get<UserSubscriptionDTO[]>(this.userSubscriptionUrl, httpOptions);
  }

  getUserSubscriptionNumbers(): Observable<any> {
    return this.http.get<UserSubscriptionNumberDTO[]>(this.userSubscriptionNumbersAdminUrl, httpOptions);
  }

  createUserSubscription(userSubscription: UserSubscriptionWriteDTO) {
    return this.http.post<UserSubscriptionDTO>(this.userSubscriptionAdminUrl, userSubscription, httpOptions);
  }

  updateUserSubscription(id: number, userSubscription: UserSubscriptionWriteDTO) {
    return this.http.put<UserSubscriptionDTO>(this.userSubscriptionAdminUrl + "/" + id, userSubscription, httpOptions);
  }

  getFeatureSubscriptions(): Observable<any> {
    return this.http.get<FeatureSubscriptionDTO[]>(this.featureSubscriptionsAdminUrl, httpOptions);
  }

  deleteFeatureSubscription(id: number): Observable<any> {
    return this.http.delete(this.featureSubscriptionAdminUrl + "/" + id, httpOptions);
  }

  createFeatureSubscription(featureSubscription: FeatureSubscriptionWriteDTO): Observable<any> {
    return this.http.post(this.featureSubscriptionAdminUrl, featureSubscription, httpOptions);
  }

  createCheckoutSession(userId: number, subscriptionId: number): Observable<any> {
    return this.http.post(this.createCheckoutSessionUrl + '?userId=' + userId + '&subscriptionId=' + subscriptionId, httpOptions);
  }

  createPortalSession(userId: number): Observable<any> {
    return this.http.post(this.createPortalSessionUrl + '?userId=' + userId, httpOptions);
  }
}
